import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ka'); // Default to Georgian

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ka' ? 'en' : 'ka');
  };

  const setLanguageTo = (lang) => {
    setLanguage(lang);
  };

  const value = {
    language,
    toggleLanguage,
    setLanguageTo,
    isGeorgian: language === 'ka',
    isEnglish: language === 'en'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};




